// Estilo compartido para react-select, usado en Búsqueda y en los Resúmenes
// para que el control y su desplegable se vean iguales en todas las vistas.
const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderColor: state.isFocused ? '#2563eb' : '#ced4da',
    boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(37, 99, 235, 0.15)' : 'none',
    '&:hover': { borderColor: '#2563eb' },
  }),
};

export default selectStyles;
